export default __webpack_public_path__ + "static/media/TopSakura.9e2997f8.png";